<template>
    <div>欢迎</div>
</template>
<script>
    export default {
        name:'plat-dashboard',
    }
</script>



// WEBPACK FOOTER //
// src/pages/dashboard/index.vue